import { render, staticRenderFns } from "./userShxf.vue?vue&type=template&id=09bc62f1&scoped=true&"
import script from "./userShxf.vue?vue&type=script&lang=js&"
export * from "./userShxf.vue?vue&type=script&lang=js&"
import style0 from "./userShxf.vue?vue&type=style&index=0&id=09bc62f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc62f1",
  null
  
)

export default component.exports